import React from 'react';
import {StyledCard, StyledFlex, StyledTag} from "./LocationHeader.styled";
import {Flex, Tag} from "antd";
import {BackButton} from "../../index";
import {LocationHeaderProps} from "../../../models";
import {RightOutlined} from "@ant-design/icons";
import style from "./LocationHeader.module.scss";

const LocationHeader = ({showProvince,onBackBtn,citiesTag,onDeleteClick}:LocationHeaderProps) => {


    return (
        <StyledCard >
            <Flex

                vertical gap={"middle"}>
                <Flex justify={"start"}  align={"center"} gap={"middle"}>
                    {showProvince ? <BackButton/>:
                        <RightOutlined onClick={() => onBackBtn(true)} className={style.customIcon}/>
                    }
                    <span>انتخاب شهر</span>

                </Flex>
               <StyledFlex>
                   {citiesTag.map((tag: any) => (<span key={tag.id} style={{display: 'inline-block'}}>
      <StyledTag
          closable
          onClose={(e: any) => {
              e.preventDefault();
              const checked = false
              const item = tag;
              onDeleteClick({item, checked});
          }}
      >
        {tag.name}
      </StyledTag>
    </span>))}

               </StyledFlex>
            </Flex>
        </StyledCard>

    );
};

export default LocationHeader;
